<template>
    <modal name="assignCardDeckModal" width="400px" height="auto" :scrollable="true">
        <div class="modal-content">
            <div class="d-flex flex-column align-items-center mt-2">
                <inline-svg src="/assets/img/logo/logo_small_hand_up.svg"></inline-svg>
                <div class="dashboard-card-title mt-3">Share with Heroes</div>
                <span class="dashboard-card-description ps-3 pe-3">
                    Select the Heroes you want to share this Card Deck with. The Card Deck will appear in their <span class="dashboard-card-description__bold">MagnusCards app</span>.
                </span>
            </div>
            <div class="modal-body d-flex flex-column align-items-center">
                <div>
                    <div class="d-flex flex-row justify-content-left align-items-center mb-2" v-for="user in heroes">
                        <form-checkbox v-model="user.assigned" class="me-1"></form-checkbox>
                        <user-avatar :user="user" size="small" :displayName="true"></user-avatar>
                    </div>
                </div>
            </div>
            <div class="divider mb-1"></div>
            <div class="modal-footer justify-content-center">
                <btn class="btn-outline-light flex-1" @click="$modal.hide('assignCardDeckModal')">Cancel</btn>
                <btn class="btn btn-primary flex-1" :loading="loading.save" @click="assignHeroes">Save</btn>
            </div>
        </div>
    </modal>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import FormCheckbox from "@/components/core/FormCheckbox.vue";

export default {
    name: "CardDeckAssign",
    components: { UserAvatar, FormCheckbox },
    props: ['heroes', 'cardDeck'],
    data() {
        return {
            loading: {
                data: false,
                save: false,
            },
        };
    },
    methods: {
        assignHeroes() {
            this.loading.save = true;
            this.$http.post('/deck/assign-heroes', { deck_id: this.cardDeck.id, heroes: this.heroes })
                .then(function (res) {
                    this.loading.save = false;
                    this.$events.$emit('loadMyCardDecks');
                    this.$modal.hide('assignCardDeckModal')
                }).catch(() => {
                this.loading.save = false;
            });
        },
    }
}
</script>

<style scoped>

</style>
